module.exports = __webpack_public_path__ + "bccca05f132278b70df0919aaf354620.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/dashboard-activities.png
// module id = 1663
// module chunks = 0